import React, { Component } from 'react';
import {
  Button,
  Form,
  Message
} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import {
  translate
} from 'react-i18next';
class RecoveryForm extends Component {

  render () {
    let {
      loading,
      error,
      message,
      email,
      createInputHandler,
      t,
      onSubmit
    } = this.props;


    const eMessage = (message) => {
      return t(`recover.errors.${message.toLowerCase().substring(0,20).replace(/\./g,'')}`) || message;
    };

    return (
      <Form loading={loading} error={!!error}>
        {/*<Form.Input label={t("recover.form.fields.accountNumber")} value={accountNumber} onChange={createInputHandler('accountNumber')} />*/}
        <Form.Input label={t("recover.form.fields.email")} type="email" value={email} onChange={createInputHandler('email')} />
        <Button primary icon="send" fluid content={t("recover.form.buttons.send")} onClick={onSubmit} />
        {
          error &&
            <Message negative
              icon="warning sign"
              header={eMessage(error.name)}
              content={eMessage(error.message)} />
        }
        {
          message &&
            <Message positive
              icon="mail"
              header={t(`${message}.title`)}
              content={t(`${message}.description`)} />
        }
      </Form>
    );
  }

}

RecoveryForm.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.object,
  accountNumber: PropTypes.string,
  email: PropTypes.string,
  createInputHandler: PropTypes.func,
  onSubmit: PropTypes.func
};

RecoveryForm.defaultProps = {
  loading: false,
  error: null
};
const i18nEnhancement = translate('translations')(RecoveryForm);
export default i18nEnhancement;



// WEBPACK FOOTER //
// ./src/components/forms/RecoverForm.jsx